module.exports = __webpack_public_path__ + "static/media/google_logo.fd5adb6d.svg";